var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47 12.334a4.688 4.688 0 10-5.187 0 7.46 7.46 0 00-3.54 2.727.61.61 0 00-.046.648.633.633 0 00.555.336h11.25a.633.633 0 00.554-.336.61.61 0 00-.047-.648 7.46 7.46 0 00-3.539-2.727z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.383 15.063a7.522 7.522 0 00-3.547-2.727 4.68 4.68 0 00-2.594-8.586 5 5 0 00-1.273.172.64.64 0 00-.422.406.626.626 0 00.094.57 5.922 5.922 0 01.296 6.633.633.633 0 00.165.828c.234.183.46.37.68.563l.038.039a8.794 8.794 0 011.992 2.726.617.617 0 00.563.36h3.492a.633.633 0 00.626-.666.624.624 0 00-.11-.319z",
    fill: "#fff"
  })));
}

export default SvgUsers;